import React, {PureComponent} from 'react';

export default class Separator extends PureComponent {
  render() {
    return(
      <div className="w-full" style={{ height:1,backgroundColor:"rgba(21, 34, 50, 0.12)",marginTop:30,marginBottom:30 }} />
    );
  }
}